import { ContactName } from '../../templates';
import { Button, NavLink } from '../../components';
import { useContacts, ContactsListTemplate } from '../../templates';

const Messages = () => {
  const listResult = useContacts();

  return (
    <ContactsListTemplate
      listResult={listResult}
      columns={[
        {
          header: 'Contact Name',
          sortName: 'email',
          cellClassName: 'text-small',
          getValue: contact => <ContactName contact={contact} />,
        },
        {
          header: 'Actions',
          align: 'right',
          getValue: item => (
            <NavLink to={`/messages_history/${item.id}`}>
              <Button icon="eye" tooltip="View Messages" />
            </NavLink>
          ),
        },
      ]}
    />
  );
};

export default Messages;
